import DownloadPdf from './DownloadPdf';
import DownloadZip from './DownloadZip';
import DownloadZipWithDirectories from './DownloadZipWithDirectories';
import s from './DownloadArchive.module.scss';

type Props =
  & Parameters<typeof DownloadPdf>[0]
  & Parameters<typeof DownloadZip>[0]
  & Parameters<typeof DownloadZipWithDirectories>[0]
  & {
    isFoldered: boolean;
  };

const DownloadArchive: React.FC<Props> = ({ accessToken, className, documents, userWorkflow, isFoldered }) => {
  if (documents.length === 0) {
    return null;
  }

  return (
    <div className={s.wrapper}>
      <DownloadPdf
        userWorkflow={userWorkflow}
        documents={documents}
        accessToken={accessToken}
        className={className}
      />
      {isFoldered
        ? (
          <DownloadZipWithDirectories
            userWorkflow={userWorkflow}
            documents={documents}
            accessToken={accessToken}
            className={className}
          />
        )
        : (
          <DownloadZip
            userWorkflow={userWorkflow}
            documents={documents}
            accessToken={accessToken}
            className={className}
          />
        )
      }
    </div>
  );
};

export default DownloadArchive;
